import React from 'react';

import { fetchBrowseHomePagePreview } from 'app/actions/browse/browseHomeActions';
import AdminBrowseHomePreviewPage from 'app/components/admin/browse/home/AdminBrowseHomePreviewPage';
import connectRoute from 'app/routes/connectRoute';

const getRouteData = ({ dispatch, params }) => {
  const { browseHomePageId, localeCode } = params;

  return [
    dispatch(
      fetchBrowseHomePagePreview({
        browseHomePageId,
        localeCode
      })
    )
  ];
};

export function AdminBrowseHomePreviewPageRoute() {
  return <AdminBrowseHomePreviewPage />;
}
export default connectRoute(AdminBrowseHomePreviewPageRoute, { getRouteData });
